import { useCallback, useEffect, useRef } from "react";

// Keeps a scroll container tail-following the newest content at the bottom,
// unless the user scrolls up to read earlier history. Pass the content that
// changes in `deps`; pass `repinWhen` (e.g. a drawer's open flag) to snap back
// to the bottom whenever it becomes true.
export const useTailFollow = <T extends HTMLElement = HTMLDivElement>(
  deps: unknown[],
  repinWhen?: boolean
) => {
  const scrollRef = useRef<T>(null);
  const followRef = useRef(true);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) {
      return;
    }
    followRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 32;
  }, []);

  useEffect(() => {
    if (repinWhen) {
      followRef.current = true;
    }
  }, [repinWhen]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !followRef.current) {
      return;
    }
    el.scrollTop = el.scrollHeight;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { scrollRef, handleScroll };
};
